export const links = [
    {
      title: "LinkedIn",
      hover_description:
        "My LinkedIn Profile",
      image: "./images/linkedin.png",
      link: "https://www.linkedin.com/in/charlottelimwt/",
      size: "50",
    },
    {
      title: "School Website",
      hover_description:
        "My Main School Website",
      image: "./images/website-1.png",
      link: "https://deunitato.github.io/NUSCSMODS/",
      size: "50",

    },
    {
      title: "Email",
      hover_description:
        "Contact me",
      image: "./images/email.png",
      link: "mailto:help.nuscsmods@gmail.com",
      size: "50",
    },
  ];